import React, {Fragment, Suspense} from "react";
import { useLocation } from "react-router-dom";

// Third-party styles
import "bootstrap/dist/css/bootstrap.min.css";
import "nouislider/dist/nouislider.css";
import "jsvectormap/dist/css/jsvectormap.min.css";
import "react-datepicker/dist/react-datepicker.min.css"

// Icon fonts
import "@/assets/scss/Icons.scss";

// App styles
import './index.css';
import './styles/theme.css';

import configureFakeBackend from "@/helpers/fake-backend.ts";
import AllRoutes from "@/routes/Routes.tsx";
import PublicRoutes from "@/routes/public";
import AppProvidersWrapper from "@/components/AppProvidersWrapper.tsx";

configureFakeBackend();

function App() {
    // Deployment verification log
    console.log('🚀 [StonkFU] App loaded - DEPLOYMENT VERSION: deb2b31-nuclear-cache-clearing');

    const location = useLocation();
    const isPublicRoute = location.pathname.startsWith('/auth') || location.pathname === '/landing';

    return (
        <>
            <Fragment>
                <AppProvidersWrapper>
                    {isPublicRoute ? (
                        <Suspense fallback={<div className="text-center p-5">Loading...</div>}>
                            <PublicRoutes />
                        </Suspense>
                    ) : (
                        <Suspense fallback={<div className="text-center p-5">Loading...</div>}>
                            <AllRoutes/>
                        </Suspense>
                    )}
                </AppProvidersWrapper>
            </Fragment>
        </>
    )
}

export default App
